export const SECOND = 1000;
export const IN_MINUTE = SECOND * 60;
export const IN_FIFTEEN_MINUTE = IN_MINUTE * 15;
export const IN_THIRTY_MINUTE = IN_FIFTEEN_MINUTE * 2;
export const IN_HOUR = IN_THIRTY_MINUTE * 2;


export const getSlotDuration = (startTime, endTime) => {
	// This function will return slot duration.
	const diff = new Date(endTime).getTime() - new Date(startTime).getTime();
	return diff / IN_MINUTE;
};

export const calculateTotalSlots = (dayStartTime, dayEndTime, slotTime) => {
	// This function will calculate total slots.
	const splitStartTime = dayStartTime.split(':');
	const startTime = new Date(new Date(new Date().setHours(splitStartTime[0])).setMinutes(splitStartTime[1]));

	const splitEndTime = dayEndTime.split(':');
	const endTime = new Date(new Date(new Date().setHours(splitEndTime[0])).setMinutes(splitEndTime[1]));

	const diff = endTime.getTime() - startTime.getTime();

	return diff / IN_MINUTE / slotTime;
};

export const getFollowingSlotStartTime = (startTime, slotTime, counter) => {
	if (counter === 0) {
		return new Date(startTime);
	}
	return new Date(new Date(startTime).getTime() + (slotTime * counter * IN_MINUTE));
};


export const getNextSlotTime = (currentSlotTime, duration) => new Date(new Date(currentSlotTime).getTime() + (duration * IN_MINUTE));
